import { useMemo, useState } from "react";
import { SearchIcon } from "../../icons";
import { useSelector } from "react-redux";
import { GetCurrenySymbol } from "../../../helper";
import { formatCryptoValue } from "../../utils/format";


const CryptoAccountRow = ({ account, onSelect }) => (
  <button
    type="button"
    onClick={() => onSelect?.(account)}
    className="flex h-[70px] w-full shrink-0 items-center justify-between rounded-[12px] bg-background-alt px-3 py-[15px] text-left custom-transition hover:bg-option-hover"
  >
    <div className="flex min-w-0 items-center gap-2.5">
      <div
        className="flex size-9 shrink-0 items-center justify-center overflow-hidden rounded-full"
        style={account.iconBg ? { backgroundColor: account.iconBg } : undefined}
      >
        <img
          src={account.logo}
          alt={account.currency_code}
          className="size-9 rounded-full object-cover"
        />
      </div>
      <div className="min-w-0">
        <p className="text-sm font-semibold leading-[19.5px] text-text-primary">
          {account.currency_code}
        </p>
        <p className="text-xs font-normal leading-[16.5px] text-text-secondary">
          {account.title}
        </p>
      </div>
    </div>
    <div className="flex shrink-0 flex-col items-end">
      <p className="flex items-center justify-center space-x-1 whitespace-nowrap text-sm font-medium leading-[19.5px] text-text-primary">
        {/* {account.valueLabel} */}
        <span>{GetCurrenySymbol(account.currency_code, 12, 12)}</span>
        <span>{formatCryptoValue(account.balance, account?.decimals || 8)}</span>
      </p>
      {/* <PercentChange value={account.change24h} positive={account.positive} /> */}
    </div>
  </button>
);

const SelectCryptoAccountStep = ({ onAccountSelect }) => {
  const [search, setSearch] = useState("");
  const cryptoAccounts = useSelector((state) => state.client.clientInfo.crypto_accounts);

  const filteredAccounts = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return cryptoAccounts ?? [];

    return (cryptoAccounts ?? []).filter((account) => {
      const addresses = account.cryptoAddresses ?? [];

      return (
        account.currency_code?.toLowerCase().includes(query) ||
        account.currency_name?.toLowerCase().includes(query) ||
        account.title?.toLowerCase().includes(query) ||
        addresses.some((address) =>
            address.network?.toLowerCase().includes(query) ||
            address.crypto_address?.toLowerCase().includes(query)
        )
      );
    });
  }, [search, cryptoAccounts]);

  return (
    <div className="flex h-full min-h-0 flex-col  sm:gap-4 gap-6 px-4  sm:pt-4 pt-6">
      <h3 className="shrink-0 px-2  sm:text-lg text-base font-semibold leading-7 text-text-primary">
        Select Source Assets
      </h3>

      <div className="flex min-h-0 flex-1 flex-col gap-4">
        <div className="flex h-10 w-full shrink-0 items-center gap-2 rounded-[10px] border border-divider bg-background-alt py-2.5 pl-4 pr-3">
          <SearchIcon />
          <input
            type="text"
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            placeholder="Search you assets..."
            className="w-full border-0 bg-transparent p-0 text-xs font-normal leading-normal text-text-primary placeholder:text-text-secondary outline-none focus:border-0 focus:outline-none focus:ring-0"
          />
        </div>

        <div className="flex shrink-0 flex-col gap-1">
          {/* <p className="shrink-0 text-sm font-medium leading-7 text-text-primary">
            Your Accounts
          </p> */}
          <div className="flex max-h-[450px] flex-col gap-2 overflow-y-auto pr-1.5 custom-scrollbar">
            {filteredAccounts.map((account) => (
              <CryptoAccountRow
                key={account.id}
                account={account}
                onSelect={onAccountSelect}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectCryptoAccountStep;
